<template>
  <span
    v-if="message"
    class="automation-header__usage-warning"
    :class="{ 'automation-header__usage-warning--limit-reached': limitReached }"
  >
    <i
      class="automation-header__usage-warning-icon iconoir-warning-triangle"
    ></i>
    {{ message }}
  </span>
</template>

<script>
import SubscriptionsService from '@saas/services/subscriptions'
import { AutomationUsageThresholdNotificationType } from '@saas/notificationTypes.jsx'

export default {
  name: 'AutomationUsageHeaderWarning',
  props: {
    workspace: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      limitReached: false,
      warningThreshold: null,
    }
  },
  computed: {
    message() {
      if (this.limitReached) {
        return this.$t('automationUsageHeaderWarning.limitReached')
      }
      if (this.warningThreshold !== null) {
        return this.$t('automationUsageHeaderWarning.warning', {
          threshold: this.warningThreshold,
        })
      }
      return null
    },
    latestThresholdNotificationId() {
      const notification = this.$store.getters['notification/getAll'].find(
        (n) =>
          n.type === AutomationUsageThresholdNotificationType.getType() &&
          n.data?.workspace_id === this.workspace.id
      )
      return notification?.id ?? null
    },
  },
  watch: {
    'workspace.id': {
      immediate: true,
      handler() {
        this.fetchUsage()
      },
    },
    // When a new notification arrives, refresh from the backend so the header
    // reflects the new state.
    latestThresholdNotificationId(newId) {
      if (newId !== null) {
        this.fetchUsage()
      }
    },
  },
  methods: {
    async fetchUsage() {
      try {
        const { data } = await SubscriptionsService(
          this.$client
        ).getAutomationUsage(this.workspace.id)
        this.limitReached = data.limit_reached
        this.warningThreshold = data.warning_threshold
      } catch (error) {
        this.limitReached = false
        this.warningThreshold = null
      }
    },
  },
}
</script>
